import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";
import { WEB_MENU_IDS } from "@/config/web-menus";
import { authorized } from "@/utils/authorized";
Vue.use(VueRouter);

let originPush = VueRouter.prototype.push; //备份原push方法
VueRouter.prototype.push = function (location, resolve, reject) {
  if (resolve && reject) {
    // 如果传了回调函数，直接使用
    originPush.call(this, location, resolve, reject);
  } else {
    // 如果没有传回调函数，手动添加
    originPush.call(
      this,
      location,
      () => {},
      () => {}
    );
  }
};

const routes = [
  // 首页
  {
    path: "/",
    component: () => import("@/views/home/HomeView"),
    meta: {
      requiresAuth: true,
    },
    children: [
      // 统计面板
      {
        path: "/statistic",
        name: "statistic",
        component: () => import("@/views/home/statistic/HomeStatistic"),
        meta: {
          parentNode: WEB_MENU_IDS.STATISTICS_PANEL,
          title: "统计面板",
          code: "SYSTEM_STATISTIC",
          menuId: WEB_MENU_IDS.STATISTICS_PANEL,
        },
      },
      // 门店管理
      {
        path: "/shop",
        name: "shop",
        component: () => import("@/views/home/shop/HomeShop"),
        meta: {
          parentNode: WEB_MENU_IDS.SHOP_MANAGE_SHOP,
          title: "门店管理",
          code: "SYSTEM_SHOP-MANAGE",
          menuId: WEB_MENU_IDS.SHOP_MANAGE_SHOP,
        },
      },
      // 教练管理
      {
        path: "/coach",
        name: "coach",
        component: () => import("@/views/home/coach/HomeCoach"),
        meta: {
          parentNode: WEB_MENU_IDS.SHOP_MANAGE_COACH,
          title: "教练管理",
          code: "SYSTEM_COACH-MANAGE",
          menuId: WEB_MENU_IDS.SHOP_MANAGE_COACH,
        },
      },
      // 学员中心
      {
        path: "/student",
        name: "student",
        component: () => import("@/views/home/student/HomeStudent"),
        meta: {
          parentNode: WEB_MENU_IDS.STUDENT_MANAGE_CENTER,
          title: "学员中心",
          code: "SYSTEM_STUDENT-MANAGE",
          menuId: WEB_MENU_IDS.STUDENT_MANAGE_CENTER,
        },
      },
      // 学员反馈
      {
        path: "/feedback",
        name: "feedback",
        component: () => import("@/views/home/feedback/HomeFeedback"),
        meta: {
          parentNode: WEB_MENU_IDS.STUDENT_MANAGE_FEEDBACK,
          title: "学员反馈",
          code: "SYSTEM_FEEDBACK-MANAGE",
          menuId: WEB_MENU_IDS.STUDENT_MANAGE_FEEDBACK,
        },
      },
      // 票务管理
      {
        path: "/ticket",
        name: "ticket",
        component: () => import("@/views/home/ticket/HomeTicket"),
        meta: {
          parentNode: WEB_MENU_IDS.TICKET_MANAGE,
          title: "票务管理",
          code: "SYSTEM_TICKET-MANAGE",
          menuId: WEB_MENU_IDS.TICKET_MANAGE,
        },
      },
      // 账号管理
      {
        path: "/account",
        name: "account",
        component: () => import("@/views/home/account/HomeAccount"),
        meta: {
          parentNode: WEB_MENU_IDS.SYSTEM_CONFIG_ACCOUNT,
          title: "账号管理",
          code: "SYSTEM_ACCOUNT-MANAGE",
          menuId: WEB_MENU_IDS.SYSTEM_CONFIG_ACCOUNT,
        },
      },
      // 角色管理
      {
        path: "/role",
        name: "role",
        component: () => import("@/views/home/role/HomeRole"),
        meta: {
          parentNode: WEB_MENU_IDS.SYSTEM_CONFIG_ROLE,
          title: "角色管理",
          code: "SYSTEM_ROLE-MANAGE",
          menuId: WEB_MENU_IDS.SYSTEM_CONFIG_ROLE,
        },
      },
      // 活动
      {
        path: "/activity",
        name: "activity",
        component: () => import("@/views/home/activity/HomeActivity"),
        meta: {
          parentNode: WEB_MENU_IDS.COMMUNITY_MANAGE_ACTIVITY,
          title: "活动设置",
          code: "SYSTEM_ACTIVITY-MANAGE",
          menuId: WEB_MENU_IDS.COMMUNITY_MANAGE_ACTIVITY,
        },
      },
      // 授课记录
      {
        path: "/record",
        name: "record",
        component: () => import("@/views/home/coach/CourseRecord"),
        meta: {
          parentNode: WEB_MENU_IDS.SHOP_MANAGE_COACH,
          title: "累计授课",
        },
      },
      // 销售记录
      {
        path: "/coach-sale",
        name: "coach-sale",
        component: () => import("@/views/home/coach/SaleRecord"),
        meta: {
          parentNode: WEB_MENU_IDS.SHOP_MANAGE_COACH,
          title: "累计销售",
        },
      },
      // 课程管理
      {
        path: "/course",
        name: "course",
        component: () => import("@/views/home/course/HomeCourse"),
        meta: {
          parentNode: WEB_MENU_IDS.COURSE_MANAGE_RECORD,
          title: "课程管理",
          code: "SYSTEM_COURSE-MANAGE",
          menuId: WEB_MENU_IDS.COURSE_MANAGE_RECORD,
        },
      },
      // 销售管理
      {
        path: "/sale",
        name: "sale",
        component: () => import("@/views/home/sale/HomeSale"),
        meta: {
          parentNode: WEB_MENU_IDS.SHOP_MANAGE_SALES,
          title: "销售管理",
          code: "SYSTEM_COURSE-SALE",
          menuId: WEB_MENU_IDS.SHOP_MANAGE_SALES,
        },
      },
      // 产品管理
      {
        path: "/product",
        name: "product",
        component: () => import("@/views/home/product/HomeProduct"),
        meta: {
          parentNode: WEB_MENU_IDS.PRODUCT_MANAGE_PRODUCT,
          title: "产品管理",
          code: "SYSTEM_PRODUCT-MANAGE",
          menuId: WEB_MENU_IDS.PRODUCT_MANAGE_PRODUCT,
        },
      },
      // 折扣管理
      {
        path: "/discount",
        name: "discount",
        component: () => import("@/views/home/discount/HomeDiscount"),
        meta: {
          parentNode: WEB_MENU_IDS.PRODUCT_MANAGE_DISCOUNT,
          title: "折扣管理",
          code: "SYSTEM_DISCOUNT-MANAGE",
          menuId: WEB_MENU_IDS.PRODUCT_MANAGE_DISCOUNT,
        },
      },
      // 圈子管理
      {
        path: "/community",
        name: "community",
        component: () => import("@/views/home/community/HomeCommunity"),
        meta: {
          parentNode: WEB_MENU_IDS.COMMUNITY_MANAGE_COMMUNITY,
          title: "圈子管理",
          code: "SYSTEM_COMMUNITY-MANAGE",
          menuId: WEB_MENU_IDS.COMMUNITY_MANAGE_COMMUNITY,
        },
      },
      // 课程表管理
      {
        path: "/class",
        name: "class",
        component: () => import("@/views/home/class/HomeClass"),
        meta: {
          parentNode: WEB_MENU_IDS.COURSE_MANAGE_SCHEDULE,
          title: "课程表管理",
          code: "SYSTEM_CLASS-MANAGE",
          menuId: WEB_MENU_IDS.COURSE_MANAGE_SCHEDULE,
        },
      },
      // 合同管理
      {
        path: "/esign",
        name: "esign",
        component: () => import("@/views/home/esign/HomeEsign"),
        meta: {
          parentNode: WEB_MENU_IDS.THIRD_CONFIG_CONTRACT,
          title: "合同管理",
          code: "SYSTEM_CONTRACT-MANAGE",
          menuId: WEB_MENU_IDS.THIRD_CONFIG_CONTRACT,
        },
      },
      // 终端管理
      {
        path: "/terminal",
        name: "terminal",
        component: () => import("@/views/home/terminal/HomeTerminal"),
        meta: {
          parentNode: WEB_MENU_IDS.THIRD_CONFIG_TERMINAL,
          title: "终端管理",
          code: "SYSTEM_TERMINAL-MANAGE",
          menuId: WEB_MENU_IDS.THIRD_CONFIG_TERMINAL,
        },
      },
      // 标签管理
      {
        path: "/tag",
        name: "tag",
        component: () => import("@/views/home/tag/HomeTag"),
        meta: {
          parentNode: WEB_MENU_IDS.COMMUNITY_MANAGE_TAG,
          title: "标签管理",
          code: "SYSTEM_TAG-MANAGE",
          menuId: WEB_MENU_IDS.COMMUNITY_MANAGE_TAG,
        },
      },
      // 保险管理
      {
        path: "/insurance",
        name: "insurance",
        component: () => import("@/views/home/insurance/HomeInsurance"),
        meta: {
          parentNode: WEB_MENU_IDS.THIRD_CONFIG_INSURANCE,
          title: "保险管理",
          code: "SYSTEM_INSURANCE-MANAGE",
          menuId: WEB_MENU_IDS.THIRD_CONFIG_INSURANCE,
        },
      },
      // 订单详情
      {
        path: "/order-details",
        name: "order-details",
        component: () => import("@/views/home/sale/order-details/OrderDetails"),
        meta: {
          parentNode: WEB_MENU_IDS.SHOP_MANAGE_SALES,
          title: "订单详情",
        },
      },
      // 保险订单详情
      {
        path: "/insurance-order-details",
        name: "insurance-order-details",
        component: () => import("@/views/home/insurance/OrderDetails"),
        meta: {
          parentNode: WEB_MENU_IDS.THIRD_CONFIG_INSURANCE,
          title: "订单详情",
        },
      },
      // 任务中心
      {
        path: "/task",
        name: "task",
        component: () => import("@/views/home/task/HomeTask"),
        meta: {
          parentNode: WEB_MENU_IDS.SHOP_MANAGE_TASK,
          title: "任务中心",
          code: "SYSTEM_TASK-MANAGE",
          menuId: WEB_MENU_IDS.SHOP_MANAGE_TASK,
        },
      },
      // 成就中心
      {
        path: "/achievement",
        name: "achievement",
        component: () => import("@/views/home/achievement/HomeAchievement"),
        meta: {
          parentNode: WEB_MENU_IDS.STUDENT_MANAGE_ACHIEVEMENT,
          title: "成就中心",
          code: "SYSTEM_ACHIEVEMENT-MANAGE",
          menuId: WEB_MENU_IDS.STUDENT_MANAGE_ACHIEVEMENT,
        },
      },
      // 积分中心
      {
        path: "/points",
        name: "points",
        component: () => import("@/views/home/points/HomePoints"),
        meta: {
          parentNode: WEB_MENU_IDS.STUDENT_MANAGE_POINTS,
          title: "积分中心",
          code: "SYSTEM_POINTS-MANAGE",
          menuId: WEB_MENU_IDS.STUDENT_MANAGE_POINTS,
        },
      },
      // 题目管理
      {
        path: "/question",
        name: "question",
        component: () => import("@/views/home/exam/question/HomeQuestion"),
        meta: {
          parentNode: WEB_MENU_IDS.EXAM_MANAGE_QUESTION,
          title: "题目管理",
          code: "SYSTEM_EXAM-MANAGE_QUESTION",
          menuId: WEB_MENU_IDS.EXAM_MANAGE_QUESTION,
        },
      },
      // 考试配置
      {
        path: "/exam-config",
        name: "exam-config",
        component: () => import("@/views/home/exam/exam-config/HomeExamConfig"),
        meta: {
          parentNode: WEB_MENU_IDS.EXAM_MANAGE_EXAM_CONFIG,
          title: "考试配置",
          code: "SYSTEM_EXAM-MANAGE_CONFIG",
          menuId: WEB_MENU_IDS.EXAM_MANAGE_EXAM_CONFIG,
        },
      },
      // 成绩记录
      {
        path: "/score-record",
        name: "score-record",
        component: () =>
          import("@/views/home/exam/score-record/HomeScoreRecord"),
        meta: {
          parentNode: WEB_MENU_IDS.EXAM_MANAGE_SCORE_RECORD,
          title: "成绩记录",
          code: "SYSTEM_EXAM-MANAGE_EXAM-RECORD",
          menuId: WEB_MENU_IDS.EXAM_MANAGE_SCORE_RECORD,
        },
      },
      // 专项考试
      {
        path: "/unify-exam",
        name: "unify-exam",
        component: () => import("@/views/home/exam/unify-exam/HomeUnifyExam"),
        meta: {
          parentNode: WEB_MENU_IDS.EXAM_MANAGE_UNIFY_EXAM,
          title: "专项考试",
          code: "SYSTEM_EXAM-MANAGE_UNIFY-EXAM",
          menuId: WEB_MENU_IDS.EXAM_MANAGE_UNIFY_EXAM,
        },
      },
      // 规则配置
      {
        path: "/course-config",
        name: "course-config",
        component: () => import("@/views/home/rule/course-config/HomeCourseConfig"),
        meta: {
          parentNode: WEB_MENU_IDS.RULE_MANAGE_COURSE_CONFIG,
          title: "课程规则配置",
          code: "SYSTEM_RULE-MANAGE_COURSE-CONFIG",
          menuId: WEB_MENU_IDS.RULE_MANAGE_COURSE_CONFIG,
        },
      },
      // 系统推送规则配置
      {
        path: "/notice-config",
        name: "notice-config",
        component: () => import("@/views/home/rule/notice-config/HomeNoticeConfig"),
        meta: {
          parentNode: WEB_MENU_IDS.RULE_MANAGE_NOTICE_CONFIG,
          title: "系统推送规则配置",
          code: "SYSTEM_RULE-MANAGE_NOTICE-CONFIG",
          menuId: WEB_MENU_IDS.RULE_MANAGE_NOTICE_CONFIG,
        },
      },
      // 装备结算公式
      // {
      //   path: "/equipment-settlement-formula",
      //   name: "equipment-settlement-formula",
      //   component: () => import("@/views/home/settlement/equipment-settlement-formula/HomeEquipmentSettlementFormula"),
      //   meta: {
      //     parentNode: WEB_MENU_IDS.SETTLEMENT_MANAGE_EQUIPMENT_SETTLEMENT_FORMULA,
      //     title: "装备结算公式",
      //     code: "SYSTEM_SETTLEMENT-MANAGE_EQUIPMENT-SETTLEMENT-FORMULA",
      //     menuId: WEB_MENU_IDS.SETTLEMENT_MANAGE_EQUIPMENT_SETTLEMENT_FORMULA,
      //   },
      // },
      // 装备结算配置
      {
        path: "/equipment-settlement-config",
        name: "equipment-settlement-config",
        component: () => import("@/views/home/settlement/equipment-settlement-config/HomeEquipmentSettlementConfig"),
        meta: {
          parentNode: WEB_MENU_IDS.SYSTEM_SETTLE_MANAGE_EQUIPMENT_CONFIG,
          title: "装备结算配置",
          code: "SYSTEM_SETTLE-MANAGE_EQUIPMENT-CONFIG",
          menuId: WEB_MENU_IDS.SYSTEM_SETTLE_MANAGE_EQUIPMENT_CONFIG,
        },
      },
      // 装备结算列表
      {
        path: "/equipment-settlement-list",
        name: "equipment-settlement-list",
        component: () => import("@/views/home/settlement/equipment-settlement-list/HomeEquipmentSettlementList"),
        meta: {
          parentNode: WEB_MENU_IDS.SYSTEM_SETTLE_MANAGE_EQUIPMENT_LIST,
          title: "装备结算列表",
          code: "SYSTEM_SETTLE-MANAGE_EQUIPMENT-LIST",
          menuId: WEB_MENU_IDS.SYSTEM_SETTLE_MANAGE_EQUIPMENT_LIST,
        },
      },
      // 装备结算详情
      {
        path: "/equipment-settlement-detail",
        name: "equipment-settlement-detail",
        component: () => import("@/views/home/settlement/equipment-settlement-detail/EquipmentSettlementDetail"),
        meta: {
          parentNode: WEB_MENU_IDS.SYSTEM_SETTLE_MANAGE_EQUIPMENT_LIST,
          title: "装备结算详情",
          code: "SYSTEM_SETTLE-MANAGE_EQUIPMENT-DETAIL",
          menuId: WEB_MENU_IDS.SYSTEM_SETTLE_MANAGE_EQUIPMENT_DETAIL,
        },
      },
      // 消课结算配置
      // {
      //   path: "/course-settlement-config",
      //   name: "course-settlement-config",
      //   component: () => import("@/views/home/settlement/course-settlement-config/HomeCourseSettlementConfig"),
      //   meta: {
      //     parentNode: WEB_MENU_IDS.SETTLEMENT_MANAGE_COURSE_SETTLEMENT_CONFIG,
      //     title: "消课结算配置",
      //     code: "SYSTEM_SETTLEMENT-MANAGE_COURSE-SETTLEMENT-CONFIG",
      //     menuId: WEB_MENU_IDS.SETTLEMENT_MANAGE_COURSE_SETTLEMENT_CONFIG,
      //   },
      // },
      // 教练消课汇总
      {
        path: "/course-settlement-list",
        name: "course-settlement-list",
        component: () => import("@/views/home/settlement/course-settlement-list/HomeCourseSettlementList"),
        meta: {
          parentNode: WEB_MENU_IDS.SYSTEM_SETTLE_MANAGE_COACH_CONSUME_SUMMARY,
          title: "教练消课汇总",
          code: "SYSTEM_SETTLE-MANAGE_COACH-CONSUME-SUMMARY",
          menuId: WEB_MENU_IDS.SYSTEM_SETTLE_MANAGE_COACH_CONSUME_SUMMARY,
        },
      },
      // 消课结算详情
      {
        path: "/course-settlement-detail",
        name: "course-settlement-detail",
        component: () => import("@/views/home/settlement/course-settlement-detail/CourseSettlementDetail"),
        meta: {
          parentNode: WEB_MENU_IDS.SYSTEM_SETTLE_MANAGE_COACH_CONSUME_SUMMARY,
          title: "消课结算详情",
          code: "SYSTEM_SETTLE-MANAGE_COACH-CONSUME-DETAIL",
          menuId: WEB_MENU_IDS.SYSTEM_SETTLE_MANAGE_COACH_CONSUME_DETAIL,
        },
      },
      // 系统审核流程配置
      {
        path: "/audit-flow-config",
        name: "audit-flow-config",
        component: () => import("@/views/home/rule/audit-flow-config/HomeAuditFlowConfig"),
        meta: {
          parentNode: WEB_MENU_IDS.RULE_MANAGE_AUDIT_FLOW_CONFIG,
          title: "系统审核流程配置",
          code: "SYSTEM_RULE-MANAGE_AUDIT-FLOW-CONFIG",
          menuId: WEB_MENU_IDS.RULE_MANAGE_AUDIT_FLOW_CONFIG,
        },
      },
      // 功能费用配置
      {
        path: "/subscription/module",
        name: "module",
        component: () => import("@/views/home/subscription/module/HomeModule"),
        meta: {
          parentNode: WEB_MENU_IDS.SYSTEM_FUNCTION_MANAGE_FEE_CONFIG,
          title: "功能费用配置",
          code: "SYSTEM_FUNCTION-MANAGE_FEE-CONFIG",
          menuId: WEB_MENU_IDS.SYSTEM_FUNCTION_MANAGE_FEE_CONFIG,
        },
      },
      // 套餐详情
      {
        path: "/subscription/module-details",
        name: "module-details",
        component: () => import("@/views/home/subscription/module/ModuleDetails"),
        meta: {
          parentNode: WEB_MENU_IDS.SYSTEM_FUNCTION_MANAGE_FEE_CONFIG,
          title: "套餐详情",
          code: "SYSTEM_FUNCTION-MANAGE_FEE-CONFIG_DETAIL",
          menuId: WEB_MENU_IDS.SYSTEM_FUNCTION_MANAGE_FEE_CONFIG_DETAIL,
        },
        },
      // 付费功能订单
      {
        path: "/subscription/order-list",
        name: "order-list",
        component: () => import("@/views/home/subscription/order-list/HomeOrderList"),
        meta: {
          parentNode: WEB_MENU_IDS.SYSTEM_FUNCTION_MANAGE_PAID_ORDER,
          title: "付费功能订单",
          code: "SYSTEM_FUNCTION-MANAGE_PAID-ORDER",
          menuId: WEB_MENU_IDS.SYSTEM_FUNCTION_MANAGE_PAID_ORDER,
        },
      },
      // 付费功能订单详情
      {
        path: "/subscription/order-details",
        name: "order-details",
        component: () => import("@/views/home/subscription/order-list/OrderDetails"),
        meta: {
          parentNode: WEB_MENU_IDS.SYSTEM_FUNCTION_MANAGE_PAID_ORDER,
          title: "付费功能订单详情",
          code: "SYSTEM_FUNCTION-MANAGE_PAID-ORDER_DETAIL",
          menuId: WEB_MENU_IDS.SYSTEM_FUNCTION_MANAGE_PAID_ORDER_DETAIL,
        },
      },
      // 付费功能退款
      {
        path: "/subscription/refund",
        name: "refund",
        component: () => import("@/views/home/subscription/refund/HomeRefundManage"),
        meta: {
          parentNode: WEB_MENU_IDS.SYSTEM_FUNCTION_MANAGE_PAID_REFUND,
          title: "付费功能退款",
          code: "SYSTEM_FUNCTION-MANAGE_PAID-REFUND",
          menuId: WEB_MENU_IDS.SYSTEM_FUNCTION_MANAGE_PAID_REFUND,
        },
      },
      // 白名单
      {
        path: "/subscription/white-list",
        name: "white-list",
        component: () => import("@/views/home/subscription/white-list/HomeWhiteList"),
        meta: {
          parentNode: WEB_MENU_IDS.SYSTEM_FUNCTION_MANAGE_WHITELIST,
          title: "白名单",
          code: "SYSTEM_FUNCTION-MANAGE_WHITELIST",
          menuId: WEB_MENU_IDS.SYSTEM_FUNCTION_MANAGE_WHITELIST,
        },
      },
      // 商户管理
      {
        path: "/partner/tenant",
        name: "tenant",
        component: () => import("@/views/home/partner/tenant/HomeTenant"),
        meta: {
          parentNode: WEB_MENU_IDS.PARTNER_MANAGE_TENANT_MANAGE,
          title: "商户管理",
          code: "PARTNER_MANAGE_TENANT",
          menuId: WEB_MENU_IDS.PARTNER_MANAGE_TENANT_MANAGE,
        },
      },
      // 商户角色
      {
        path: "/partner/tenant-role",
        name: "tenant-role",
        component: () => import("@/views/home/partner/tenant-role/HomeTenantRole"),
        meta: {
          parentNode: WEB_MENU_IDS.PARTNER_MANAGE_TENANT_ROLE,
          title: "商户角色",
          code: "PARTNER_MANAGE_TENANT_ROLE",
          menuId: WEB_MENU_IDS.PARTNER_MANAGE_TENANT_ROLE,
        },
      },
      // 门店申请管理
      {
        path: "/partner/shop-apply",
        name: "shop-apply",
        component: () => import("@/views/home/partner/shop-apply/HomeShopApply"),
        meta: {
          parentNode: WEB_MENU_IDS.PARTNER_MANAGE_SHOP_APPLY,
          title: "门店申请管理",
          code: "PARTNER_MANAGE_SHOP_APPLY",
          menuId: WEB_MENU_IDS.PARTNER_MANAGE_SHOP_APPLY,
        },
      },
    ],
  },
  // 登录页
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/LoginView"),
  },
  // 404页面
  {
    path: "*",
    name: "error",
    component: () => import("@/views/error/ErrorView"),
    meta: {
      hasFooter: false,
      hasHeader: false,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  let token = localStorage.getItem("token");
  let requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (!token && requiresAuth) {
    // 当前未登录，且需要登录时，跳转至登录页
    next("/login");
  } else {
    let flag = to.matched.some((record) => {
      let menuId = record.meta.menuId;
      return menuId && !authorized(menuId);
    });
    if (flag) {
      // 需要相应权限，且用户不具备对应权限时，跳转至错误页
      next("/error");
    } else {
      // 其它情况均放行
      next();
    }
  }
  if (!from.meta.parentNode) {
    store.state.routerList = [];
  }
});

export default router;
